import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { nodeToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

export class MadCapEquationSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapequation: {
      group: 'inline',
      inline: true,
      content: '(math | mmlmath | text)*',
      atom: true,
      definingForContent: true,
      parseDOM: [{
        tag: 'MadCap\\:equation'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:equation'
    },
    /*
     * The <math> tag shouldn't normally exist on its own. It should have gotten wrapped by a <MadCap:equation> tag.
     * We treat a bare <math> tag like a <MadCap:equation> tag either way: PBI #186777 added MathLive-based
     * equation editing, but MathML content (bare or wrapped in <MadCap:equation>) is deliberately excluded from
     * it and stays read-only — MathLive's LaTeX-based editing round-trip isn't lossless for raw MathML. See the
     * content-shape check in EquationNodeView.enterEditMode().
     */
    math: {
      group: 'inline',
      inline: true,
      attrs: {
        content: { default: undefined, skipExport: true, skipEditorExport: true }
      },
      parseDOM: [{
        tag: 'math',
        getAttrs: function (dom: HTMLElement) {
          return {
            content: dom.outerHTML
          };
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        return nodeToFlareXML(node, options, 'math', {
          xml: node.attrs.content
        });
      }
    }
  } satisfies Record<string, NodeSpec>;
}
